import { SearchInput } from '@alefeducation/ui-elements-library-core';
import React, { useEffect, useState } from 'react';
import { SEARCH_BOX_PLACEHOLDER } from '../../utils/constants';

interface Props {
  onChange: (text: string) => void;
}

const SearchBox = ({ onChange }: Props) => {
  const [searchText, setSearchText] = useState('');

  useEffect(() => {
    onChange(searchText);
  }, [searchText]);

  return (
    <SearchInput
      data-testid="search-box"
      width="310px"
      value={searchText}
      placeholder={SEARCH_BOX_PLACEHOLDER}
      onChange={(e) => {
        setSearchText(e.target.value);
      }}
      onClear={() => {
        setSearchText('');
      }}
      onSearch={() => {}}
    />
  );
};

export default SearchBox;
